export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerVisible: false,
    };
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    }
  },
  watch: {
    visible(v) {
      this.innerVisible = v;
    },
    innerVisible(v) {
      this.$emit('update:visible', v);
    }
  },
  beforeDestroy() {
    this.innerVisible = false;
    this.close();
  },
};
